import {Hub} from 'yougile-model'
import {SelectedPinStickers} from '../types'

export const getPinInitStickers = (editHub?: Hub): SelectedPinStickers => {
  const values = editHub?.data?.movementTemplate?.pinStickers
  return (values ?? {}) as SelectedPinStickers
}
